import { Box, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const Header = ({ children, title, titleLink, className = '', classNameTitle = '' }) => (
  <Box 
    bgcolor='primary.main' 
    color="primary.contrastText" 
    className={`bg-primary text-primary-foreground px-4 py-2 h-screen-module-header flex items-center justify-between gap-2 ${className}`}
  >
    { title && 
      titleLink ?
      <Link to={titleLink}>
        <Typography variant='h6' className={`uppercase ${classNameTitle}`}>{title}</Typography> 
      </Link> :
      <Typography variant='h6' className={`uppercase ${classNameTitle}`}>{title}</Typography>
    }
    {children}
  </Box>
)

export default Header